
















import { createComponent, reactive } from "@vue/composition-api";

interface Props {
  error: boolean;
  message: string;
  display: boolean;
}

export default createComponent({
  name: "SnackBar",
  components: {},
  props: {
    error: {
      type: Boolean,
      require: true
    },
    message: {
      type: String,
      require: true
    },
    display: {
      type: Boolean,
      require: true
    }
  },
  setup(props: Props) {
    const snackbar = reactive({
      error: props.error,
      message: props.message,
      display: true
    });

    return { snackbar };
  }
});
